<template>
  <div class="loading">
    <div class="sub">
      <img src="../../assets/img/common/loading1.gif" alt="">
      <p>{{text}}</p>
    </div>
  </div>
</template>

<script>
	export default {
    methods:{},
    props:{
      text:{
        type: [String],
        default:'请等待...',
      }
    }
  }
</script>

<style  lang="less" rel="stylesheet/less" scoped>
.loading{
  position:fixed;
  z-index:30;
  top:0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  background: rgba(34,34,34,.7);
  .sub{
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%);
  }
  img{
    width: 62px;
    height: 62px;
  }
  p{
    color: #ffffff;
    margin-top: 20px;
  }

}
</style>




// WEBPACK FOOTER //
// src/components/basic/videoloading.vue